<!--
  钱包
  lovi 2020-1-9
-->
<template>
  <div class="w100">
    <van-nav-bar class="gradient"  :fixed="true">
    </van-nav-bar>

    <div class="content-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="money-wrap">
          <dl>
            <dt>
              <span>
                {{ $t("common.balance") }}
              </span>
              <van-icon
                :name="walletEye ? 'eye-o' : 'closed-eye'"
                @click="changeEye"
              />
            </dt>
            <dd>
              <h3>{{ walletEye ? userInfo.money_usable : "*****" }}</h3>
              <span>PHP</span>
            </dd>
          </dl>
        </div>

        <van-grid :column-num="2">
          <van-grid-item
            icon="icon1"
            @click="_linkFun('/recharge')"
            :text="$t('wallet.recharge')"
          />
          <van-grid-item
            icon="icon2"
            @click="_linkFun('/withdraw')"
            :text="$t('wallet.withdraw')"
          />
          <van-grid-item
            icon="icon3"
            @click="_linkFun('/transfer')"
            :text="$t('wallet.transfer')"
          />
          <van-grid-item
            icon="icon4"
            @click="_linkFun('/bankCard')"
            :text="$t('wallet.bankCard')"
          />
          <van-grid-item
            icon="icon5"
            @click="_linkFun('/appointment')"
            :text="$t('wallet.reservationHandleCard')"
          />
          <van-grid-item
            icon="icon6"
            @click="_linkFun('/bill')"
            :text="$t('wallet.billDetail')"
          />
        </van-grid>
      </scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "wallet",
  meta: {
    tabNav: true, // 显示菜单
    service: false // 客服
  },
  components: {},
  data() {
    return {
      walletEye: localStorage.getItem("walletEye")
        ? JSON.parse(localStorage.getItem("walletEye"))
        : true
    };
  },
  created() {
    this.$store.dispatch("GET_USER_INFO");
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    _getWalletInfo() {
      // 获取钱包信息
      this.$post("/app/Help/walletInfo", {}, { loading: true }).then(res => {
        console.log("walletInfo", res);
        this.walletInfo = res[0].select;
      });
    },

    changeEye() {
      // 切换金额显示
      this.walletEye = !this.walletEye;
      localStorage.setItem("walletEye", this.walletEye);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.content-wrapper {
  // background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}
.money-wrap {
  margin: 0 15px;
  height: 130px;
  padding: 15px;
  color: #fff;
  line-height: 1;
  background: url("~@/assets/images/wallet/card_bg1@2x.png") no-repeat;
  background-size: cover;
  border-radius: 8px;
  dl {
    dt,
    dd {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    dt {
      height: 20px;
      font-size: 14px;
      /deep/.van-icon {
        margin-left: 10px;
        font-size: 16px;
      }
    }
    dd {
      margin-top: 10px;
      height: 30px;
      font-size: 16px;
      h3 {
        font-size: 32px;
        font-weight: 500;
        color: #fff;
        text-shadow: 0px 1px 2px rgba(93, 58, 0, 0.31);
      }
      span {
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}

/deep/.van-grid {
  padding: 15px;
  &.van-hairline--top::after {
    border: 0;
  }
  .van-grid-item {
    &:nth-child(2),
    &:nth-child(4),
    &:nth-child(6) {
      .van-grid-item__content::after {
        border-right: 0;
      }
    }
    &:nth-child(5),
    &:nth-child(6) {
      .van-grid-item__content::after {
        border-bottom: 0;
      }
    }
    .van-icon {
      width: 45px;
      height: 45px;
      background-size: 100%;
      &.van-icon-icon1 {
        background-image: url("@{images}wallet/icon_chongzhi@2x.png");
      }
      &.van-icon-icon2 {
        background-image: url("@{images}wallet/icon_tixian@2x.png");
      }
      &.van-icon-icon3 {
        background-image: url("@{images}wallet/icon_zhuanzhang@2x.png");
      }
      &.van-icon-icon4 {
        background-image: url("@{images}wallet/icon_yinhangka@2x.png");
      }
      &.van-icon-icon5 {
        background-image: url("@{images}wallet/icon_yuyue@2x.png");
      }
      &.van-icon-icon6 {
        background-image: url("@{images}wallet/icon_zhangdan@2x.png");
      }
    }
    .van-grid-item__text {
      font-size: 16px;
      line-height: 1.2;
      text-align: center;
    }
  }
}
</style>
